import { useState, useEffect, memo } from "react";
import { keys } from "idb-keyval";
import { getKiinteistoImagesByKiinteistoId } from "../../api/api";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { unstable_batchedUpdates } from "react-dom";
import { pdfCacheEvents } from "./ImageHandler";

function PdfReadyImagesChecker({ propertyId }) {
  const [totalImages, setTotalImages] = useState(0);
  const [cachedImages, setCachedImages] = useState(0);
  const [readyPercentage, setReadyPercentage] = useState(0);
  const [uncachedImages, setUncachedImages] = useState([]);
  const [images, setImages] = useState([]);

  useEffect(() => {
    if (!propertyId) return;

    const fetchAllImages = async () => {
      try {
        const res = await getKiinteistoImagesByKiinteistoId(propertyId, {
          fetchLimit: 9999,
          requestPageNumber: 1,
        });
        const imgs = res.data?.rows || [];
        setImages(imgs);
        setTotalImages(imgs.length);
      } catch (err) {
        console.error(err);
      }
    };

    fetchAllImages();
  }, [propertyId]);

  useEffect(() => {
    if (!images.length) return;

    const checkCached = async () => {
      const allKeys = await keys();
      let cachedCount = 0;
      const uncached = [];
      images.forEach((img) => {
        const pattern = new RegExp(`^pdf-final-${propertyId}-${img.id}-`);
        if (allKeys.some((key) => pattern.test(key))) {
          cachedCount++;
        } else {
          uncached.push(img.metadata?.description || `Image ${img.id}`);
        }
      });
      unstable_batchedUpdates(() => {
        setCachedImages(cachedCount);
        setUncachedImages(uncached);
        setReadyPercentage(
          images.length ? Math.round((cachedCount / images.length) * 100) : 0
        );
      });
    };

    checkCached(); // initial check on mount

    // Update whenever a new pdf-final key is written (no more polling)
    const handler = (e) => {
      if (e.detail.propertyId === propertyId) checkCached();
    };
    pdfCacheEvents.addEventListener("progress", handler);
    return () => pdfCacheEvents.removeEventListener("progress", handler);
  }, [images, propertyId]);

  return (
    <div className="pdf-ready-status d-flex align-items-center gap-2">
      <strong>PDF-pakatut kuvat:</strong> {cachedImages} / {totalImages} (
      {readyPercentage}%)
      {uncachedImages.length > 0 && (
        <OverlayTrigger
          placement="right"
          overlay={
            <Tooltip id={`tooltip-${propertyId}`}>
              <div style={{ maxHeight: 200, overflowY: "auto" }}>
                <strong>Not ready:</strong>
                <ul className="mb-0">
                  {uncachedImages.map((desc, idx) => (
                    <li key={idx}>{desc}</li>
                  ))}
                </ul>
              </div>
            </Tooltip>
          }
        >
          <i className="bi bi-info-circle" style={{ cursor: "pointer" }} />
        </OverlayTrigger>
      )}
    </div>
  );
}

export default memo(PdfReadyImagesChecker);
